import {Card, CardContent, CardMedia, CardProps, Typography} from "@mui/material";
import {ArmDocument} from "../../../equipmentdb/types/pj1dbApiArm";

export interface ArmListItemProps extends CardProps {
  arm: ArmDocument
}

export function ArmListItem({arm, ...props}: ArmListItemProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Card {...props} sx={{width: 240, height: 200, ...props.sx}}>
      <CardMedia
        component="img"
        height="145"
        image={arm.url?.image[0]}
        alt={arm.attr.armInfo.name}
        sx={{objectFit: "scale-down"}}
      />
      <CardContent sx={{py: 0.5, px: 1, m: 0}}>
        <Typography variant="subtitle2" noWrap component='p' sx={{mt: 0.5}}>
          製品名：{arm.attr.armInfo.name}
        </Typography>
        <Typography variant="subtitle2" noWrap component='p' sx={{color: "#888"}}>
          製造者：{arm.attr.armInfo.manufacturer}
        </Typography>
      </CardContent>
    </Card>
  )
}
